// module.exports = {
//   apiUrl: 'https://api-erp.loadshare.net/',
//   angularUrl: 'https://atlas.loadshare.net/',
//   reactUrl: 'https://atlas.loadshare.net',
//   buildFolder: 'dist/',
//   baseUrl: 'https://atlas.loadshare.net/',
//   logoutUrlSass: 'https://atlas.loadshare.net/sical_logistics',
//   devEnvType: 'prod',
//   node_port: 4000,
//   otpConfig: {
//     minutes: 3,
//     seconds: 59,
//     exotelNumber: "08047092838"
//   }
// };

module.exports = {
    apiUrl: "https://api-erp.loadshare.net/",
    reportUrl: "https://api-reports.loadshare.net/",
    erpIdUrl: "https://api-erp-id.loadshare.net/",
    angularUrl: "https://client.loadshare.net/",
    reactUrl: "https://client.loadshare.net",
    buildFolder: "dist/",
    baseUrl: "https://client.loadshare.net/",
    logoutUrlSass: "https://client.loadshare.net/sical_logistics",
    systemStatusUrl: "https://loadshare-v2.s3.ap-south-1.amazonaws.com/configurations/system_status.json",
    devEnvType: "prod",
    node_port: 4000,
    otpConfig: {
      minutes: 3,
      seconds: 59,
      exotelNumber: "08047092838"
    },
    beeconEntityURL:(window && window.location && window.location.protocol !== 'https:')?"http://www.beecon.in/api/trade/fleet/entity":"https://www.beecon.in/api/trade/fleet/entity",
    beeconTransactionURL: (window && window.location && window.location.protocol !== 'https:')?"http://www.beecon.in/api/trade/fleet/transaction":"https://www.beecon.in/api/trade/fleet/transaction",
    terrain : 'TERRAIN',
    road : 'ROADMAP',
    satellite : 'SATELLITE',
    hydrid : 'HYBRID'
  };
